import React from 'react';

const AgentsReportPage = () => {
  return (
    <div>
      <h1>Report Page</h1>
    </div>
  );
};

export { AgentsReportPage }; 